var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../form.html"] = require( "../form.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/modals/modalGeneric.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../form.html", false, "views/content/modals/modalGeneric.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\r\n";
if(runtime.contextOrFrameLookup(context, frame, "title")) {
output += "\r\n\t<div class=\"modal-header\">\r\n\t\t<h5 class=\"modal-title\" id=\"modalLable\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</h5>\r\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t</button>\r\n\t</div>\r\n";
;
}
output += "\r\n<form class=\"grid ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "simple")?"simple":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"lastActionArgs")),0), env.opts.autoescape);
output += "\" id=\"modalGenericSend\">\r\n\t<div class=\"modal-body\">\r\n\t\t";
if(runtime.contextOrFrameLookup(context, frame, "type") == "image") {
output += "\r\n\t\t\t<img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
output += "\" style=\"width: 100%\">\r\n\t\t";
;
}
else {
output += "\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "type") != "dialog") {
output += "\r\n\t\t\t\t<img src=\"/App_Themes/images/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += ".svg\">\r\n\t\t\t";
;
}
output += "\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "message")) {
output += "\r\n\t\t\t\t<h4>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message"), env.opts.autoescape);
output += "</h4>\r\n\t\t\t";
;
}
output += "\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "args") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")) {
output += "\r\n                <div class=\"row\">\r\n\t\t\t\t";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("col", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n\t\t\t\t\t<div class=\"col col-12\">\r\n\t\t\t\t\t\t<label class=\"form-field\" ";
if(runtime.memberLookup((t_7),"Type") == "Boolean") {
output += " style=\"display: flex; justify-content: center;\" ";
;
}
output += ">\r\n\t\t\t\t\t\t\t<div class=\"form-label text-left\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"Title"), env.opts.autoescape);
output += "</div>\r\n\t\t\t\t\t\t\t<div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((t_7),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t";
var t_8;
t_8 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("initialValue", t_8, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_8);
}
if(frame.topLevel) {
context.addExport("initialValue", t_8);
}
output += "\r\n\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_7),"Initial")) {
output += "\r\n\t\t\t\t\t\t\t\t\t";
var t_9;
t_9 = runtime.memberLookup((runtime.memberLookup((t_7),"Initial")),"Value");
frame.set("initialValue", t_9, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_9);
}
if(frame.topLevel) {
context.addExport("initialValue", t_9);
}
output += "\r\n\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 31, colno = 30, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_7,runtime.memberLookup((t_7),"Type"),runtime.contextOrFrameLookup(context, frame, "initialValue"),runtime.memberLookup((t_7),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n             </div>\r\n\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "type") == "choice") {
output += "\r\n\t\t\t\t<select name=\"choice\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_12 = runtime.contextOrFrameLookup(context, frame, "args");
if(t_12) {var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("option", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
output += "\r\n\t\t\t\t\t<option>";
output += runtime.suppressValue(t_13, env.opts.autoescape);
output += "</option>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</select>\r\n\t\t\t\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "date") {
output += "\r\n\t\t\t\t\t<div class=\"date-picker\">\r\n\t\t\t\t\t\t<input type=\"text\" name=\"givendate\" autocomplete=\"no\" class=\"editable-text date\">\r\n\t\t\t\t\t</div>\r\n\t\t\t\t";
;
}
;
}
output += "\r\n\t\t\t";
;
}
output += "\r\n\t\t";
;
}
output += "\r\n\t</div>\r\n\t<div class=\"modal-footer\">\r\n\t\t<div class=\"msg-actions\">\r\n\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "type") == "dialog") {
output += "\r\n\t\t\t\t<p class=\"button button-menu left\" data-dismiss=\"modal\" data-close data-dismiss=\"modal\" data-close>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Cancel"), env.opts.autoescape);
output += "</p>\r\n\t\t\t\t<button type=\"submit\" class=\"button button-default left\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Submit"), env.opts.autoescape);
output += "</button>\r\n\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t<div class=\"text-center\">\r\n\t\t\t\t\t<button type=\"submit\" class=\"button button-default\" data-dismiss=\"modal\" data-close>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Cancel"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\t\t</div>\r\n\t</div>\r\n</form>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/modals/modalGeneric.html"] , dependencies)